import { put, takeEvery } from 'redux-saga/effects'
import { GET_MEMEBER_INFO_LOADING, POST_MEMBER_INFO_LOADING, MEMBER_DATA_SUCCESS, MEMBER_DATA_ERROR } from "../actions/actionMember";
import { getmember, postmember } from 'api';

async function fetchAsync(func, payload) {
    const response = await func(payload);
    if (response.ok) {
        return await response.json();
    }
}

function* fetchMemberInfoData(action) {
    try {
        const data = yield fetchAsync(getmember, action.payload)
        yield put({ type: MEMBER_DATA_SUCCESS, payload: data });
    } catch (e) {
        yield put({ type: MEMBER_DATA_ERROR, error: e.message });
    }
}

function* PostMemberInfoData() {
    try {
        const data = yield fetchAsync(postmember)
        yield put({ type: MEMBER_DATA_SUCCESS, payload: data });
    } catch (e) {
        yield put({ type: MEMBER_DATA_ERROR, error: e.message });
    }
}

export const sagaMember = [
    takeEvery(GET_MEMEBER_INFO_LOADING, fetchMemberInfoData),
    takeEvery(POST_MEMBER_INFO_LOADING, PostMemberInfoData),
];
